// Scenario 5: reverse_charge_de
// German EU customer (PROFESSIONAL x 6 seats, EUR monthly) with a valid DE VAT tax ID
// on file. Tax calculation in #10 applies reverse-charge.
// Note: tax-ID type doesn't ship until #10; for now just set country/currency.

import { Scenario, TENANT_ID_DE, daysFromNow } from './scenario.types';
import { SHARED_PLANS, SHARED_TOP_UP_PACKS } from './shared-plans';

const PRICE_PER_SEAT_MINOR = 3600;   // PROFESSIONAL EUR monthly
const SEATS = 6;
const SUBTOTAL_MINOR = PRICE_PER_SEAT_MINOR * SEATS;
const TOTAL_MINOR = SUBTOTAL_MINOR;

export const reverseChargeDe: Scenario = {
  name: 'reverse_charge_de',
  subscription: {
    id: 'sub_reverse_charge_de',
    stripeSubscriptionId: null,
    tenantId: TENANT_ID_DE,
    status: 'active',
    tier: 'PROFESSIONAL',
    billingPeriod: 'monthly',
    currency: 'EUR',
    countryCode: 'DE',
    seats: SEATS,
    pricePerSeatMinor: PRICE_PER_SEAT_MINOR,
    subtotalMinor: SUBTOTAL_MINOR,
    discountMinor: 0,
    taxMinor: 0,
    totalMinor: TOTAL_MINOR,
    appliedCoupon: null,
    currentPeriodStart: daysFromNow(-5),
    currentPeriodEnd: daysFromNow(25),
    cancelAtPeriodEnd: false,
    canceledAt: null,
    pastDueSince: null,
    gracePeriodEndsAt: null
  },
  plans: SHARED_PLANS,
  invoices: [
    {
      id: 'inv_de_001',
      number: 'INV-2026-0070',
      status: 'paid',
      issuedAt: daysFromNow(-5),
      paidAt: daysFromNow(-5),
      periodStart: daysFromNow(-5),
      periodEnd: daysFromNow(25),
      currency: 'EUR',
      subtotalMinor: SUBTOTAL_MINOR,
      discountMinor: 0,
      taxMinor: 0,
      taxRate: 0,
      taxBasis: 'exclusive',
      totalMinor: TOTAL_MINOR,
      hostedInvoiceUrl: 'https://invoice.stripe.com/mock/inv_de_001',
      invoicePdfUrl: 'https://invoice.stripe.com/mock/inv_de_001.pdf',
      lineItems: [
        {
          description: 'Professional plan x 6 seats',
          kind: 'subscription',
          quantity: SEATS,
          unitAmountMinor: PRICE_PER_SEAT_MINOR,
          amountMinor: SUBTOTAL_MINOR,
          periodStart: daysFromNow(-5),
          periodEnd: daysFromNow(25)
        }
      ]
    }
  ],
  receipts: [
    {
      id: 'rcpt_de_001',
      chargedAt: daysFromNow(-5),
      amountMinor: TOTAL_MINOR,
      currency: 'EUR',
      description: 'Solo subscription renewal',
      invoiceId: 'inv_de_001',
      topUpPackId: null
    }
  ],
  paymentMethod: {
    id: 'pm_de_001',
    type: 'card',
    brand: 'visa',
    last4: '0026',
    expMonth: 9,
    expYear: 2029,
    isDefault: true
  },
  aiCreditBalance: {
    tenantId: TENANT_ID_DE,
    billingCycleStart: daysFromNow(-5),
    billingCycleEnd: daysFromNow(25),
    allocatedCredits: 6000,
    usedCredits: 1800,
    reservedCredits: 0,
    topUpBalance: 0,
    remainingCredits: 6000 - 1800,
    basicTurnsAllocated: 6000,
    basicTurnsUsed: 700
  },
  topUpPacks: SHARED_TOP_UP_PACKS
};
